import React, { useEffect, useState } from 'react';
import Modal from '../../../UI/Modal/Modal';
import cl from './AddIdCard.module.css'; 
import { useTranslation } from 'react-i18next';
import { useUser } from '../../../../hooks/useUser';

const AddIdCard = ({ defaultUser }) => {
  const { t } = useTranslation();
  const { userService } = useUser(50, true);

  const [idFront, setIdFront] = useState(null);
  const [idBack, setIdBack] = useState(null);
  const [newUser, setNewUser] = useState({ id: 0, id_front: '', id_back: '' });
  const [validates, setValidates] = useState({});
  const [isFirstValidated, setIsFirstValidated] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    setNewUser({
      id: defaultUser.id,
      id_front: defaultUser.id_front,
      id_back: defaultUser.id_back,
    });
  }, [defaultUser]);

  useEffect(() => {
    if (isFirstValidated) {
      validateUser();
    }
  }, [idFront, idBack, isFirstValidated]);

  const validateUser = () => {
    const messages = {};
    if (!idFront) {
      messages.id_front = { message: 'ატვირთეთ წინა პირადობის მოწმობა', isValid: false };
    }
    if (!idBack) {
      messages.id_back = { message: 'ატვირთეთ უკანა პირადობის მოწმობა', isValid: false };
    }
    setValidates(messages);
    return Object.keys(messages).length === 0;
  };

  const saveHandle = () => {
    if (validateUser()) {
                  const newForm = new FormData();
          
            newForm.append('idfont', idFront);
            newForm.append('idback', idBack);
            newForm.append('id', newUser.id); 

            userService.updateFiles(newForm).then(() => {
                window.location.reload();
            });

            setIsModalOpen(false);

    } else {
      setIsFirstValidated(true);
    }
  };

  const openAdd = () => {
    setValidates({});
    setIsFirstValidated(false);
    setIsModalOpen(true);
  };

  return (
    <div>
      <span className={cl.editBtn} onClick={openAdd}>
        {t('Upload')}
      </span>
      <Modal size="small" isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <div className={cl.modalHead}>
          <h3>{t('Upload')}</h3>
        </div>
        {!defaultUser.id_front && (
          <div className={`${cl.groupInput} ${validates.id_front ? cl.errorInput : ''}`}>
            <label>{t('IDFront')}</label>
            <input
              type="file"
              name="id_front"
              className={cl.input}
              onChange={e => setIdFront(e.target.files[0])}
            />
            {validates.id_front && <span className={cl.errorMsg}>{validates.id_front.message}</span>}
          </div>
        )}
        {!defaultUser.id_back && (
          <div className={`${cl.groupInput} ${validates.id_back ? cl.errorInput : ''}`}>
            <label>{t('IDBack')}</label>
            <input
              type="file"
              name="id_back"
              className={cl.input}
              onChange={e => setIdBack(e.target.files[0])}
            />
            {validates.id_back && <span className={cl.errorMsg}>{validates.id_back.message}</span>}
          </div>
        )}
        <span onClick={saveHandle} className={cl.btnPrimary}>
          {t('Save')}
        </span>
      </Modal>
    </div>
  );
};

export default AddIdCard;
